/**
 * Remove empty keys from an object
 * @param {object} obj - Object to clean
 * @returns {object} Cleaned object
 */
export const onRemoveEmptyKeys = obj => {
  if (!obj || typeof obj !== "object") return obj

  const result = { ...obj }

  Object.keys(result).forEach(key => {
    if (
      result[key] === undefined ||
      result[key] === null ||
      result[key] === ""
    ) {
      delete result[key]
    } else if (typeof result[key] === "object" && !Array.isArray(result[key])) {
      // For nested objects, remove empty keys recursively
      result[key] = onRemoveEmptyKeys(result[key])
      
      // If nested object is now empty, remove it too
      if (Object.keys(result[key]).length === 0) {
        delete result[key]
      }
    } else if (Array.isArray(result[key])) {
      if (result[key].length === 0) {
        // Remove empty arrays
        delete result[key]
      } else {
        // Process objects within arrays
        result[key] = result[key].map(item => 
          typeof item === 'object' && item !== null ? onRemoveEmptyKeys(item) : item
        )
        
        // If array becomes empty after processing, remove it
        if (result[key].length === 0) {
          delete result[key]
        }
      }
    }
  })

  return result
}

export default onRemoveEmptyKeys
